import React, { useContext, useEffect, useState } from 'react';
import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, IconButton, CircularProgress } from '@mui/material';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';
import { Zoom } from '@mui/material';
import Box from '@mui/material/Box';
import { Autocomplete } from '@mui/material';
import { dzongkhagList, gewogList } from '../../../services/PlaceServices';
import { museumInitialValue } from './MuseumModel';
import { MultipleImageUpload } from '../../../common/ImageUpload/MultipleImage';
import { museumApi, museumServicesAction } from '../../../services/MuseumServices';
import { mastersApi } from '../../../services/MasterDataServices';
import { SNACKBAR_OPEN } from '../../../reducers';
import { DispatchContext } from '../../../store';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import { getVisitorTypesForDropdown } from './MuseumModel';
import { Select, FormControl, InputLabel } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{ transitionDelay: '150ms' }} ref={ref} {...props} />;
});

export default function CreateMuseum({ open, handleAction, museumId, museums, setMuseums }) {
  const dispatch = useContext(DispatchContext);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [museumInitial, setMuseumInitial] = useState(museumInitialValue);
  const [dzongkhag, setDzongkhag] = useState([]);
  const [gewogs, setGewogs] = useState([]);
  const [code, setCode] = useState('en');
  const [musImgIds, setMusImgIds] = useState([]);
  const [museumTypes, setMuseumTypes] = useState([]);
  const [visitorTypes, setVisitorTypes] = useState([]);
  const show = Boolean(anchorEl);
  const [isDistrict, setIsDistrict] = useState(false);
  const [isGewog, setIsGewog] = useState(false);
  const noLoading = dispatch({ type: 'IS_NOT_LOADING', payload: false });

  useEffect(() => {
    if (open && museumId) {
      museumServicesAction('get', museumId).then(res => {
        const photoArray = Object.values(res?.data?.photos || {}).map(photo => photo?.file);
        setMuseumInitial({
          ...res?.data,
          dzongkhag_id: res?.data?.dzongkhag_id,
          gewog_id: res?.data?.gewog_id,
          museum_type_id: res?.data?.museum_type?.id || null,
          photo_ids: photoArray,
          translations: {
            en: {
              name: res?.data?.name,
              description: res?.data?.description,
            },
            dz: {
              name: res?.data?.name,
              description: res?.data?.description
            }
          },
        });
      });
      if (museumInitial?.dzongkhag_id) {
        getGewog(museumInitial?.dzongkhag_id);
      }
    }
  }, [noLoading, museumInitial?.dzongkhag_id, open]);

  useEffect(() => {
    getDzongkhag();
    getMuseumTypes();
    getVisitorTypes();
  }, [noLoading]);

  const getVisitorTypes = async () => {
    const types = await getVisitorTypesForDropdown();
    setVisitorTypes(types);
  };

  const getMuseumTypes = () => {
    mastersApi('museum_types', 'get').then(res => {
      setMuseumTypes(res?.data || []);
    }).catch(err => {
      console.error('Failed to load museum types:', err);
    });
  };

  const getDzongkhag = () => {
    dzongkhagList('get', null, { per_page: 20 }).then(res => {
      setDzongkhag(res?.data);
      setIsDistrict(true);
    })
  }

  const getGewog = (id) => {
    gewogList('get', id, null).then(res => {
      setGewogs(res?.data);
      setIsGewog(true);
    })
  }

  const [selectedDzongkhag, setSelectedDzongkhag] = useState(null);

  useEffect(() => {
    const initialDzongkhag = dzongkhag.find(
      option => parseInt(option.id) === parseInt(museumInitial?.dzongkhag_id)
    );

    setSelectedDzongkhag(initialDzongkhag || null);
  }, [noLoading, museumInitial?.dzongkhag_id, dzongkhag]);

  const findOptionById = (id) => {
    return dzongkhag.find(option => parseInt(option.id) === parseInt(id));
  };

  const [selectedGewog, setSelectedGewog] = useState(
    gewogs.find(option => parseInt(option.id) === parseInt(museumInitial.gewog_id)) || null
  );

  const onSubmit = async (values, { resetForm, setSubmitting }) => {
    if (!values.translations.en.name && !values.translations.en.description) {
      delete values.translations.en;
    }

    
    const museumData = {
      dzongkhag_id: values?.dzongkhag_id,
      gewog_id: values?.gewog_id,
      museum_type_id: values?.museum_type_id,
      agency_code: values?.agency_code,
      date_of_establishment: values?.date_of_establishment,
      photo_ids: musImgIds.map(id => parseInt(id)),
      tenant_code: values?.tenant_code,
      counter_code: values?.counter_code,
      office_code: values?.office_code,
      translations: {
        en: {
          name: values?.translations?.en?.name,
          description: values?.translations?.en?.description
        },
        dz: {
          name: values?.translations?.dz?.name || values?.translations?.en?.name,
          description: values?.translations?.dz?.description || values?.translations?.en?.description
        }
      },
      services: values?.services || []
    }

    const museumUpdatedData = {
      dzongkhag_id: values?.dzongkhag_id,
      gewog_id: values?.gewog_id,
      museum_type_id: values?.museum_type_id,
      agency_code: values?.agency_code,
      date_of_establishment: values?.date_of_establishment,
      photo_ids: (values?.photos || musImgIds).map(id => parseInt(id?.id) || parseInt(id)) || [],
      tenant_code: values?.tenant_code,
      counter_code: values?.counter_code,
      office_code: values?.office_code,
      translations: {
        en: {
          name: values?.translations?.en?.name,
          description: values?.translations?.en?.description
        },
        dz: {
          name: values?.translations?.en?.name,
          description: values?.translations?.en?.description
        }
      },
      services: values?.services || []
    }

    try {
      setSubmitting(true);
      if (museumId) {
        const res = await museumServicesAction('put', museumId, { ...museumUpdatedData });
        const updatedMuseums = museums?.map(museum =>
          museum?.id === museumId ? res.data : museum
        );
        setMuseums(updatedMuseums);
        dispatch({
          type: SNACKBAR_OPEN,
          payload: { isNotify: true, severity: 'success', message: 'Museum updated successfully' }
        });
      } else {
        await museumApi('post', { ...museumData });
        dispatch({
          type: SNACKBAR_OPEN,
          payload: { isNotify: true, severity: 'success', message: 'Museum created successfully' }
        });
      }
      resetForm();
      handleAction();
    } catch (error) {
      console.error('Failed to save museum:', error);
    } finally {
      setSubmitting(false);
    }
  }

  const changeToDzongkha = () => {
    setCode('dz');
    handleClose();
  }

  const changeToEnglish = () => {
    setCode('en');
    handleClose();
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleAction}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="md"
      width="50%"
    >
      <DialogTitle color={'#616B88'} className={'text-bold space-between'} sx={{ fontSize: 25, alignItems: 'center' }}
        fontWeight={700}>
        {museumId ? 'Update Museum' : 'Create Museum'}
        {/*<Button*/}
        {/*  variant={'outlined'}*/}
        {/*  id="fade-button"*/}
        {/*  className={'box-shadow-outlined'}*/}
        {/*  aria-controls={open ? 'fade-menu' : undefined}*/}
        {/*  aria-haspopup="true"*/}
        {/*  aria-expanded={open ? 'true' : undefined}*/}
        {/*  onClick={handleClick}*/}
        {/*>*/}
        {/*  {code === 'en' ?*/}
        {/*    <div className={'space-between'}>*/}
        {/*      <Avatar sx={{width: 25, height: 25, mr: 1}}*/}
        {/*              src={require('../../../assets/Images/en.png')} alt={'en'}/>*/}
        {/*      <Typography>EN</Typography>*/}
        {/*      <KeyboardArrowDownRoundedIcon/>*/}
        {/*    </div>*/}
        {/*    :*/}
        {/*    <div className={'space-between'}>*/}
        {/*      <Avatar sx={{width: 25, height: 25, mr: 1}}*/}
        {/*              src={require('../../../assets/Images/dz.png')} alt={'en'}/>*/}
        {/*      <Typography>DZ</Typography>*/}
        {/*      <KeyboardArrowDownRoundedIcon/>*/}
        {/*    </div>*/}
        {/*  }*/}
        {/*</Button>*/}
        <Menu
          id="fade-menu"
          MenuListProps={{
            'aria-labelledby': 'fade-button',
          }}
          anchorEl={anchorEl}
          open={show}
          onClose={handleClose}
          TransitionComponent={Fade}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem onClick={changeToEnglish}>
            <Avatar sx={{ width: 25, height: 25, mr: 1 }}
              src={require('../../../assets/Images/en.png')} alt={'en'} />
            EN
          </MenuItem>
          <MenuItem onClick={changeToDzongkha}>
            <Avatar sx={{ width: 25, height: 25, mr: 1 }}
              src={require('../../../assets/Images/dz.png')} alt={'en'} />
            DZ
          </MenuItem>
        </Menu>
      </DialogTitle>
      <Box className={'common-divider'} />
      <Formik initialValues={museumInitial}
        onSubmit={onSubmit}
        // validationSchema={museumValidation}
        validateOnBlur={true} enableReinitialize
      >
        {({ isSubmitting, touched, errors, values, setFieldValue, ...formik }) => (
          <Form>
            <DialogContent sx={{ height: '70vh', overflowY: 'auto' }}>
              <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                label={
                  <div>
                    <span style={{ color: 'red' }}>*</span>
                    {code === 'en' ? 'Museum Name' : 'འགྲེམས་སྟོན་ཁང་།'}
                  </div>
                }
                name={`translations.${code}.name`}
                InputLabelProps={{
                  style: { fontSize: 14, color: '#929191' },
                  shrink: true
                }}
              />
              {isDistrict &&
                <Autocomplete
                  id="combo-box-demo"
                  options={dzongkhag}
                  value={findOptionById(selectedDzongkhag?.id) || null}
                  getOptionLabel={(option) => option?.name}
                  size={'small'}
                  className="dob mr-2 mt-3"
                  onChange={(e, value) => {
                    getGewog(value?.id || null);
                    setSelectedDzongkhag(value);
                    setFieldValue('dzongkhag_id', value?.id);
                  }}
                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  renderInput={(params) => <Field component={TextField} {...params}
                    label={
                      <div>
                        <span style={{ color: 'red' }}>*</span>
                        Dzongkhag
                      </div>}
                    sx={{ mt: 1.5 }}
                    InputLabelProps={{ style: { color: '#000', fontSize: 14 }, shrink: true }}
                    name="dzongkhag_id" />}
                />
              }
              {isGewog &&
                <Autocomplete
                  id="combo-box-demo"
                  options={gewogs}
                  value={selectedGewog || gewogs?.find(option => parseInt(option?.id) === parseInt(values?.gewog_id))}
                  getOptionLabel={(option) => option?.name}
                  size={'small'}
                  className="dob mr-2 mt-3"
                  onChange={(e, value) => {
                    setSelectedGewog(value);
                    setFieldValue('gewog_id', value?.id || null);
                  }}
                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  renderInput={(params) => <Field component={TextField} {...params}
                    label="Gewog" sx={{ mt: 1.5 }}
                    InputLabelProps={{ style: { color: '#000', fontSize: 14 }, shrink: true }}
                    name="gewog_id" />}
                />}
              <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                label={
                  <div>
                    <span style={{ color: 'red' }}>*</span>
                    {code === 'en' ? 'Agency Code' : 'Agency'}
                  </div>
                }
                name={`agency_code`}
                InputLabelProps={{
                  style: { fontSize: 14, color: '#929191' },
                  shrink: true
                }} sx={{ mt: 1.5 }} />
              <Autocomplete
                id="museum-type"
                options={museumTypes}
                value={museumTypes.find(option => option.id === values.museum_type_id) || null}
                getOptionLabel={(option) => option?.name || ''}
                size={'small'}
                className="mt-3"
                sx={{ mt: 1.5 }}
                onChange={(e, value) => {
                  setFieldValue('museum_type_id', value?.id || null);
                }}
                renderInput={(params) => <Field component={TextField} {...params}
                  label="Museum Type"
                  InputLabelProps={{ style: { color: '#929191', fontSize: 14 }, shrink: true }}
                  name="museum_type_id" />}
              />
              <Field component={TextField} variant={'outlined'} size={'medium'} fullWidth
                label={
                  <div>
                    <span style={{ color: 'red' }}>*</span>
                    {code === 'en' ? 'Description' : 'འགྲིལ་བསྐྱེད།'}
                  </div>
                }
                name={`translations.${code}.description`} multiline={true} rows={3}
                InputLabelProps={{
                  style: { fontSize: 14, color: '#929191' },
                  shrink: true
                }} sx={{ mt: 1.5 }} />
              <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                label={'Date of Establishment'} sx={{ mt: 1.5 }}
                type={'date'} name="date_of_establishment"
                InputLabelProps={{
                  style: { fontSize: 14, color: '#929191' },
                  shrink: true
                }} />
              <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                label={
                  <div>
                    <span style={{ color: 'red' }}>*</span>
                    Tenant Code
                  </div>
                } sx={{ mt: 1.5 }} name="tenant_code"
                InputLabelProps={{
                  style: { fontSize: 14, color: '#929191' },
                  shrink: true
                }} />
              <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                label={
                  <div>
                    <span style={{ color: 'red' }}>*</span>
                    Counter Code
                  </div>
                } sx={{ mt: 1.5 }} name="counter_code"
                InputLabelProps={{
                  style: { fontSize: 14, color: '#929191' },
                  shrink: true
                }} />
              <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                label={
                  <div>
                    <span style={{ color: 'red' }}>*</span>
                    Office Code
                  </div>
                } sx={{ mt: 1.5 }} name="office_code"
                InputLabelProps={{
                  style: { fontSize: 14, color: '#929191' },
                  shrink: true
                }} />


              <MultipleImageUpload setImageId={setMusImgIds} imgId={museumId} />
              

              {/* Services Section */}
              <Box sx={{ mt: 2, mb: 1 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                  Services <span style={{ color: 'red' }}>*</span>
                </Typography>
                {values.services?.map((service, index) => (
                  <Box key={index} sx={{ mb: 2, p: 2, border: '1px solid #ddd', borderRadius: 1, position: 'relative' }}>
                    {values.services.length > 1 && (
                      <IconButton
                        size="small" color="error"
                        sx={{ position: 'absolute', top: 4, right: 4 }}
                        onClick={() => {
                          const services = values.services.filter((_, i) => i !== index);
                          setFieldValue('services', services);
                        }}
                      >
                        <RemoveCircleOutlineIcon fontSize="small" />
                      </IconButton>
                    )}
                    <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                      label="Service Code" sx={{ mb: 1 }}
                      name={`services.${index}.code`}
                      InputLabelProps={{ style: { fontSize: 14 }, shrink: true }} />
                    <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                      label="Service Name" sx={{ mb: 1 }}
                      name={`services.${index}.name`}
                      InputLabelProps={{ style: { fontSize: 14 }, shrink: true }} />
                    <FormControl size="small" fullWidth sx={{ mb: 1 }}>
                      <InputLabel>Service Type (Visitor Type)</InputLabel>
                      <Select
                        value={service.service_type}
                        onChange={(e) => setFieldValue(`services.${index}.service_type`, e.target.value)}
                        label="Service Type (Visitor Type)"
                      >
                        {visitorTypes.map(type => (
                          <MenuItem key={type.value} value={type.value}>
                            {type.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                      label="Service Description" multiline rows={2}
                      name={`services.${index}.description`}
                      InputLabelProps={{ style: { fontSize: 14 }, shrink: true }} />
                  </Box>
                ))}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    variant="outlined" size="small" className="text-capitalize"
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={() => {
                      const services = [...(values.services || [])];
                      services.push({ code: '', name: '', service_type: '', description: '' });
                      setFieldValue('services', services);
                    }}
                  >
                    Add More
                  </Button>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleAction} variant={'outlined'} color={'error'} className={'text-capitalize'}
                sx={{ width: 40, height: 30 }}>cancel</Button>
              <Button variant={'contained'} type={'submit'} className={'text-capitalize'}
                sx={{ width: 40, height: 30 }} disabled={isSubmitting}>
                {isSubmitting ? <CircularProgress size={20} color="inherit" /> : (museumId ? 'Update' : 'Create')}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}